/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { fetchBase, FetchError, FetchSuccess } from "./managers";

export const getInvitationDetails = async (eventId) => {
  try {
    const response = await fetchBase(`user-dashboard/invitation`, null, {
      slugTarget: "url",
      eventId,
    });
    return new FetchSuccess(response);
  } catch (res) {
    throw new FetchError(res);
  }
};

export const rejectInvitation = async (id, feedback, eventId) => {
  try {
    const response = await fetchBase(
      `user-dashboard/invitation/${id}`,
      {
        method: "PATCH",
        body: JSON.stringify({
          guest_response: feedback,
          status: "denied",
          selected_dates: [],
        }),
      },
      {
        slugTarget: "url",
        eventId,
      },
    );
    return new FetchSuccess(response);
  } catch (res) {
    throw new FetchError(res);
  }
};

export const approveInvitation = async (id, selectedDates, eventId) => {
  try {
    const response = await fetchBase(
      `user-dashboard/invitation/${id}`,
      {
        method: "PATCH",
        body: JSON.stringify({
          guest_response: "",
          status: "approved",
          selected_dates: selectedDates,
        }),
      },
      {
        slugTarget: "url",
        eventId,
      },
    );
    return new FetchSuccess(response);
  } catch (res) {
    throw new FetchError(res);
  }
};
